function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScMoney = function SvgScMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M4 4C4 4 4 5.83633 4 7.01297M4 7.01297C6.29258 6.8951 7 7.56709 7 9.8627M4 7.01297C1.86553 6.90323 1 7.7254 1 9.8627C1 13.2467 7 10.7532 7 14.1373C7 16.2746 6.13447 17.0967 4 16.987M4 16.987C4 18.1637 4 20 4 20M4 16.987C1.70742 17.1049 1 16.4329 1 14.1373M12 4C12 4 12 5.83633 12 7.01297M12 7.01297C14.2926 6.8951 15 7.56709 15 9.8627M12 7.01297C9.86553 6.90323 9 7.7254 9 9.8627C9 13.2467 15 10.7532 15 14.1373C15 16.2746 14.1345 17.0967 12 16.987M12 16.987C12 18.1637 12 20 12 20M12 16.987C9.70742 17.1049 9 16.4329 9 14.1373M20 4C20 4 20 5.83633 20 7.01297M20 7.01297C22.2926 6.8951 23 7.56709 23 9.8627M20 7.01297C17.8655 6.90323 17 7.7254 17 9.8627C17 13.2467 23 10.7532 23 14.1373C23 16.2746 22.1345 17.0967 20 16.987M20 16.987C20 18.1637 20 20 20 20M20 16.987C17.7074 17.1049 17 16.4329 17 14.1373",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
};
export default SvgScMoney;